/**
 * CPLA-44 — A/B test of the "More about movie" CTA on the content detail page.
 *
 * The variants, weights and split are owned by the `more-about-movie-cta` Vercel Flag
 * (see flags.ts) — nothing about the values lives in code. The only piece the app owns is
 * this cookie: a stable per-visitor id that Vercel buckets on ("Based on User › id").
 */
export const AB_CTA_COOKIE_NAME = '_cin_ab';

/**
 * Request header used to forward a freshly-minted visitor id to the *first* render.
 * A cookie set in proxy.ts isn't visible to that same request's `cookies()` (Next rebuilds
 * the RSC cookie jar from the original request), so on the first visit the flag would fall
 * back to control. proxy.ts sets this header instead — custom headers copied by next-intl
 * are readable via `headers()` — and the flag's identify reads it when the cookie is absent.
 */
export const AB_CTA_ID_HEADER = 'x-cin-ab-id';

/**
 * Key of the Vercel Flag. Shared between the flag definition (flags.ts) and the
 * `<FlagValues>` emitted to the DOM so Vercel Web Analytics tags pageviews and click
 * events with the resolved variant — that tag is the per-variant denominator for CTR.
 */
export const MORE_ABOUT_MOVIE_CTA_FLAG_KEY = 'more-about-movie-cta';
